module.exports = __webpack_public_path__ + "img/user.1b001fa4.jpg";